import * as React from 'react';
import { cn } from '@/lib/utils';

type SliderProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'defaultValue' | 'onChange'> & {
  value: number;
  min: number;
  max: number;
  step?: number;
  onValueChange?: (value: number) => void;
};

export function Slider({ className, value, min, max, step = 1, onValueChange, ...props }: SliderProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <input
        type="range"
        className="h-2 w-full cursor-pointer appearance-none rounded-full bg-secondary accent-primary"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(event) => onValueChange?.(Number(event.target.value))}
        {...props}
      />
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>{min}</span>
        <span className="font-medium text-foreground">{value}</span>
        <span>{max}</span>
      </div>
    </div>
  );
}
